/* ## MushCore Edit ## */
class MushcoreSampleOrder extends HTMLElement {
  constructor() {
    super();
    this.productId = this.dataset.productId;
    this.productUrl = this.dataset.productUrl;
    this.maxSamples = parseInt(this.dataset.maxSamples || "5", 10);
    this.button = this.querySelector(".mushcore-sample-order-btn");
    this.limitMessage = this.querySelector(".mushcore-sample-order-limit-message");
    this.imageElement = this.querySelector(".mushcore-sample-order-img");
    this.form = this.querySelector("form");

    if (!this.button) return;

    this.checkCartStatus();

    if (typeof subscribe !== "undefined" && typeof PUB_SUB_EVENTS !== "undefined") {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        setTimeout(() => this.checkCartStatus(), 100);
      });
      subscribe(PUB_SUB_EVENTS.cartItemAdd, () => {
        setTimeout(() => this.checkCartStatus(), 100);
      });
      subscribe(PUB_SUB_EVENTS.productVariantChange, (data) => {
        this.onVariantChange(data);
      });
    }
  }

  async checkCartStatus() {
    try {
      const response = await fetch(`${window.routes.cart_url}.js`);
      const cart = await response.json();
      const sampleCount = this.getSampleCount(cart);
      const atLimit = sampleCount >= this.maxSamples;

      this.button.disabled = atLimit;
      this.button.classList.toggle("is-disabled", atLimit);

      if (this.limitMessage) {
        this.limitMessage.hidden = !atLimit;
      }
    } catch (e) {
      this.button.disabled = false;
      this.button.classList.remove("is-disabled");
      if (this.limitMessage) this.limitMessage.hidden = true;
    }
  }

  getSampleCount(cart) {
    if (!cart || !cart.items) return 0;
    return cart.items.reduce((count, item) => {
      if (item.properties && item.properties._sample_for_product_id) {
        return count + item.quantity;
      }
      return count;
    }, 0);
  }

  onVariantChange(variantData) {
    if (!variantData) return;

    const variant = variantData.variant;
    if (!variant) return;

    let newImageUrl = null;
    let newImageAlt = null;

    if (variant.featured_media && variant.featured_media.preview_image) {
      newImageUrl = variant.featured_media.preview_image.src.replace(/\?.*$/, "") + "?width=600";
      newImageAlt = variant.featured_media.alt || null;
    } else if (variant.image) {
      newImageUrl = variant.image.src.replace(/\?.*$/, "") + "?width=600";
    }

    if (newImageUrl && newImageUrl.indexOf("//") === 0) {
      newImageUrl = "https:" + newImageUrl;
    }

    if (this.imageElement && newImageUrl) {
      this.imageElement.src = newImageUrl;
      if (newImageAlt) this.imageElement.alt = newImageAlt;
    }

    if (this.form) {
      const imageInput = this.form.querySelector('[name="properties[_sample_for_product_image]"]');
      if (imageInput && newImageUrl) {
        imageInput.value = newImageUrl;
      }

      const skuInput = this.form.querySelector('[name="properties[Tile SKU]"]');
      if (skuInput) {
        if (variant.sku) {
          skuInput.value = variant.sku;
          skuInput.disabled = false;
        } else {
          skuInput.value = "";
          skuInput.disabled = true;
        }
      }

      const optionInputs = this.form.querySelectorAll("[data-mushcore-option-index]");
      optionInputs.forEach((input) => {
        const optionIndex = parseInt(input.dataset.mushcoreOptionIndex, 10);
        if (variant.options && variant.options[optionIndex] != null) {
          input.value = variant.options[optionIndex];
        }
      });

      const variantIdInput = this.form.querySelector('[name="properties[_sample_for_variant_id]"]');
      if (variantIdInput && variant.id) {
        variantIdInput.value = variant.id;
      }
    }
  }
}

customElements.define("mushcore-sample-order", MushcoreSampleOrder);
/* ## END MushCore Edit ## */
